import { render, staticRenderFns } from "./ChairSettingPage.vue?vue&type=template&id=3bfad258&scoped=true"
import script from "./ChairSettingPage.vue?vue&type=script&lang=js"
export * from "./ChairSettingPage.vue?vue&type=script&lang=js"
import style0 from "./ChairSettingPage.vue?vue&type=style&index=0&id=3bfad258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfad258",
  null
  
)

export default component.exports